import React from "react";
const VoucherStats = ({ statsData, currency, revenue, clicks, locale }) => {
       const numberFormat = (value) =>
        new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: 'NZD'
        }).format(value);
    return (
        <div className="iconcards-row row">
            <div className="mb-4 col-md-3" >
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-finger-print
                        "></i>
                        <p className="card-text font-weight-semibold mb-0">Clicks</p>
                        <p className="recent-lead font-weight-semibold mb-0">
                            {clicks !== undefined ? clicks : 0}
                        </p>
                    </div>
                </div>
            </div>
            <div className="mb-4 col-md-3" >
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-sunglasses-w-3"></i>
                        <p className="card-text font-weight-semibold mb-0">Views</p>
                        <p className="recent-lead font-weight-semibold mb-0">
                            {statsData.views !== undefined ? statsData.views : 0}
                        </p>
                    </div>
                </div>
            </div>
            <div className="mb-4 col-md-3" >
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-add-cart"></i>
                        <p className="card-text font-weight-semibold mb-0">Sold</p>
                        <p className="recent-lead font-weight-semibold mb-0">
                            {statsData.sold !== undefined ? statsData.sold : 0}
                        </p>
                    </div>
                </div>
            </div>
            <div className="mb-4 col-md-3" >
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-money-bag"></i>
                        <p className="card-text font-weight-semibold mb-0">Revenue</p>
                        <p className="recent-lead font-weight-semibold mb-0">
                            {revenue !== undefined ? (numberFormat(revenue).replace(/[A-Za-z]/g, '')).substring(0, numberFormat(revenue).indexOf('.') - 2) : 0}
                        </p>
                    </div>
                </div>
            </div>
        </div >
    );
};
export default VoucherStats;